<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations 3ème pilier</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.sex || originalMetadata?.sex">
        <span class="card__label" i18n>Genre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.sex,
            }"
            >{{ getSexEnumLabel(metadata?.sex!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sex && originalMetadata?.sex !== metadata.sex
            "
            >{{ getSexEnumLabel(originalMetadata?.sex!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.situation || originalMetadata?.situation"
      >
        <span class="card__label" i18n>Situation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.situation,
            }"
            >{{ getThirdPillarSituationLabel(metadata.situation) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.situation &&
              originalMetadata?.situation !== metadata.situation
            "
            >{{
              getThirdPillarSituationLabel(originalMetadata?.situation!)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.situationDescription ||
          originalMetadata?.situationDescription
        "
      >
        <span class="card__label" i18n>Description de la situation</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.situationDescription,
            }"
            >{{ metadata.situationDescription }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.situationDescription &&
              originalMetadata?.situationDescription !==
                metadata.situationDescription
            "
            >{{ originalMetadata?.situationDescription }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.idealMonthlySaving || originalMetadata?.idealMonthlySaving
        "
      >
        <span class="card__label" i18n>Epargne mensuelle idéale</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.idealMonthlySaving,
            }"
            >{{ metadata.idealMonthlySaving }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.idealMonthlySaving &&
              originalMetadata?.idealMonthlySaving !==
                metadata.idealMonthlySaving
            "
            >{{ originalMetadata?.idealMonthlySaving }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasAlreadyThirdPillar !== null &&
            metadata?.hasAlreadyThirdPillar !== undefined) ||
          (originalMetadata?.hasAlreadyThirdPillar !== null &&
            originalMetadata?.hasAlreadyThirdPillar !== undefined)
        "
      >
        <span class="card__label" i18n>Possède déjà un 3ème pilier</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasAlreadyThirdPillar === null ||
                  originalMetadata.hasAlreadyThirdPillar === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasAlreadyThirdPillar) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasAlreadyThirdPillar &&
              originalMetadata?.hasAlreadyThirdPillar !==
                metadata.hasAlreadyThirdPillar
            "
            >{{ getBooleanLabel(originalMetadata.hasAlreadyThirdPillar) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.startDate,
            }"
            >{{ metadata?.startDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDate &&
              originalMetadata?.startDate !== metadata.startDate
            "
            >{{ originalMetadata?.startDate }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.birthDate || originalMetadata?.birthDate"
      >
        <span class="card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.birthDate,
            }"
            >{{ metadata?.birthDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.birthDate &&
              originalMetadata?.birthDate !== metadata.birthDate
            "
            >{{ originalMetadata?.birthDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.npaNumber || originalMetadata?.npaNumber"
      >
        <span class="card__label" i18n>NPA</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.npaNumber,
            }"
            >{{ metadata?.npaNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.npaNumber &&
              originalMetadata?.npaNumber !== metadata.npaNumber
            "
            >{{ originalMetadata?.npaNumber }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.ownDescription || originalMetadata?.ownDescription"
      >
        <span class="card__label" i18n>Description</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.ownDescription,
            }"
            >{{ getOwnDescriptionLabel(metadata.ownDescription) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.ownDescription &&
              originalMetadata?.ownDescription !== metadata.ownDescription
            "
            >{{
              getOwnDescriptionLabel(originalMetadata?.ownDescription!)
            }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.job || originalMetadata?.job">
        <span class="card__label" i18n>Profession</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.job,
            }"
            >{{ metadata.job }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.job && originalMetadata?.job !== metadata.job
            "
            >{{ originalMetadata?.job }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasLPPCotisation !== null &&
            metadata?.hasLPPCotisation !== undefined) ||
          (originalMetadata?.hasLPPCotisation !== null &&
            originalMetadata?.hasLPPCotisation !== undefined)
        "
      >
        <span class="card__label" i18n>Cotise à la LPP</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.hasLPPCotisation === null ||
                  originalMetadata.hasLPPCotisation === undefined),
            }"
            >{{ getBooleanLabel(metadata.hasLPPCotisation) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.hasLPPCotisation &&
              originalMetadata?.hasLPPCotisation !== metadata.hasLPPCotisation
            "
            >{{ getBooleanLabel(originalMetadata.hasLPPCotisation) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.savingReasons || originalMetadata?.savingReasons"
      >
        <span class="card__label" i18n>Raisons d'épargne</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span>
            <span
              *ngFor="let reason of metadata?.savingReasons; let isLast = last"
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  !originalMetadata?.savingReasons?.includes(reason),
              }"
            >
              {{ getSavingReasonLabel(reason)
              }}<ng-container *ngIf="!isLast">, </ng-container></span
            ></span
          >
          <span *ngIf="originalMetadata?.savingReasons">
            <span
              *ngFor="
                let reason of originalMetadata?.savingReasons;
                let isLast = last
              "
              [ngClass]="{
                'old-lead-value': !metadata?.savingReasons?.includes(reason),
              }"
            >
              {{ getSavingReasonLabel(reason)
              }}<ng-container *ngIf="!isLast">, </ng-container></span
            >
          </span>
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.alreadyThirdPillarDescription ||
          originalMetadata?.alreadyThirdPillarDescription
        "
      >
        <span class="card__label" i18n>Compagnie actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.alreadyThirdPillarDescription,
            }"
            >{{
              getCentralisationInsurerLabel(
                metadata.alreadyThirdPillarDescription
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyThirdPillarDescription &&
              originalMetadata?.alreadyThirdPillarDescription !==
                metadata.alreadyThirdPillarDescription
            "
            >{{
              getCentralisationInsurerLabel(
                originalMetadata.alreadyThirdPillarDescription
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.alreadyThirdPillarValue ||
          originalMetadata?.alreadyThirdPillarValue
        "
      >
        <span class="card__label" i18n>Cotisation mensuelle actuelle</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.alreadyThirdPillarValue,
            }"
            >{{ metadata.alreadyThirdPillarValue }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.alreadyThirdPillarValue &&
              originalMetadata?.alreadyThirdPillarValue !==
                metadata.alreadyThirdPillarValue
            "
            >{{ originalMetadata?.alreadyThirdPillarValue }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
